import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

//componentes
import { MigasDePan, Miga } from "../../../globales/MigaDePan";
import TituloSeccion from "../../../globales/estadisticas/TituloSeccion";
import TablaLibrosLeidos from "./TablaLibrosLeidos";
import { useDispatch, useTrackedState } from "../../../../store";
import { useQueryParams } from "../../../../containers/helpers/hooks/locationHooks";
import { FiltroFechas } from "../../../../utilities/gestion_fechas/FiltrosFechas";
import { ESTADISTICAS_COLUMNAS_TABLAS } from "../../../../containers/estadisticas/tablas-reportes/ColumnasTablas";
import moment from "moment";
import { DescargarReporte } from "../../Reportes/DescargarReporte";
import { CargandoInformacion } from "../../../globales/estadisticas/CargandoInformacion";
import { useFechaPorDefecto } from "../../hooks/Fechas";
import { SelectorRol } from "../../../globales/estadisticas/SelectorRol";
import { Calendario } from "../../../globales/Calendario";
import { LibrosLeidosProfesoresAPI } from "../../../../api/estadisticas/LibrosLeidosProfesoresAPI";
import { normalizeString } from "../../../../utilities/StringUtilities";
import PropTypes from "prop-types";
import { CancelRequestController } from "../../../../utilities/cancel-request-controller";

/**
 * Este componente tiene la función de cargar todas las estadísticas de los libros leídos por los profesores con base a un rango de fechas.Por otro lado, también se encarga de transformar los datos estadísticos a formato excel para que puedan ser descargados por el usuario.
 */
const LibrosLeidosProfesorComponent = (props) => {
  const { traducciones } = props;
  const { miga_de_pan, libros_leidos_profesores, botones } = traducciones;
  const { titulo, descripcion, detalle_de, tabla, resultados, resumen } = libros_leidos_profesores;


  const history = useHistory();
  const state = useTrackedState();
  const queryParams = useQueryParams();
  const fechaPorDefecto = useFechaPorDefecto();
  const dispatch = useDispatch();

  const [filtros, setFiltros] = useState({
    fechas: {
      inicio: fechaPorDefecto.fechaInicio,
      fin: fechaPorDefecto.fechaFin
    }
  })


  const [rangoFechas, setRangoFechas] = useState({
    inicio: FiltroFechas.formatoUsuario(state?.idioma, fechaPorDefecto?.fechaInicio),
    fin: FiltroFechas.formatoUsuario(state?.idioma, fechaPorDefecto?.fechaFin),
  })

  const [estadisticas, setEstadisticas] = useState({

    totalLeidos: 0,
    totalTiempoLectura: 0,
    libros: [],
    librosFiltrados: []
  });

  const [cargando, setCargando] = useState({
    estadisticas: false
  })



  const actualizarFiltros = (fechas) => {
    dispatch({
      type: "SECCION_ESTADISTICAS_FILTROS",
      property: "fechas",
      value: {inicio:fechas[0], fin:fechas[1]}
    })
    setFiltros({
      ...filtros,
      fechas: {
        inicio: fechas[0],
        fin: fechas[1]
      },
    })
  }


  const filtrarPorInput = ({ value }) => {
    if (value && value.trim().length > 0) {
      const coincidencias = estadisticas?.libros.filter(libro => normalizeString(libro?.tituloLibro)?.includes(normalizeString(value)));
      setEstadisticas({
        ...estadisticas,
        librosFiltrados: coincidencias
      })
    } else {
      setEstadisticas({
        ...estadisticas,
        librosFiltrados: estadisticas?.libros
      })
    }

  }

  /**
   * transforma la información suministrada por las APIs a una tabla que se puede descargar como excel.
   * @returns tabla para reporte
   */
  const generarInformacionTabla = () => {
    const columnas = ESTADISTICAS_COLUMNAS_TABLAS.librosLeidos.map(col => {
      const traduccion = traducciones?.libros_leidos?.tabla[`${col?.traduccion}`]
      return { nombreColumna: traduccion || col.textoPorDefecto }
    })

    const filas = [];
    estadisticas?.libros.forEach(ingreso => {
      let fila = [];
      ESTADISTICAS_COLUMNAS_TABLAS.librosLeidos.forEach(col => {
        let valor = ingreso[`${col?.propiedad}`];
        fila.push({ valor: valor })
      })
      filas.push(fila);
    })

    const tabla = {
      columnas: columnas,
      filas: filas
    }
    return tabla;
  }


  useEffect(() => {
    setRangoFechas({
      inicio: FiltroFechas.formatoUsuario(state?.idioma, filtros?.fechas?.inicio),
      fin: FiltroFechas.formatoUsuario(state?.idioma, filtros?.fechas?.fin),
    })
  }, [filtros, state?.idioma])

  useEffect(() => {
    const abortController = new CancelRequestController();
    setCargando({
      ...cargando,
      estadisticas: true
    })
    const actualizarEstadisticas = async () => {
      const rangoFechas = {
        inicio: filtros?.fechas.inicio || FiltroFechas.formatoAPI(state?.idioma, moment()),
        fin: filtros?.fechas.fin || FiltroFechas.formatoAPI(state?.idioma, moment())
      };

        await LibrosLeidosProfesoresAPI
          .obtenerTodos( {fechaInicio:rangoFechas?.inicio, fechaFin:rangoFechas?.fin, abortSignal: abortController.signal})
          .then(resultado => {
            setEstadisticas({
              ...estadisticas,
              libros: resultado,
              librosFiltrados: resultado,
              totalLeidos: resultado.reduce((acc, curr) => {
                return acc = acc + curr?.cantidadLecturas;
              }, 0),
              totalTiempoLectura: resultado.reduce((acc, curr) => {
                return acc = acc + curr?.totalTiempoLectura;
              }, 0)
            })
            setCargando({
              ...cargando,
              estadisticas: false
            })
          })
          .catch(error => console.log(error))
    }
    if (filtros?.fechas?.inicio && filtros?.fechas?.fin ) {
      actualizarEstadisticas();
    }
    return () => {
      abortController.abort();
      setCargando({ ...cargando, estadisticas: true })
    }
  }, [JSON.stringify(filtros)])



  return (
    <>
      <MigasDePan>
        <Miga
          texto={miga_de_pan?.estadisticas || 'Estadisticas'}
          alSeleccionar={() => {
            history.push('/estadisticas')
          }} />
        <Miga
          texto={miga_de_pan?.libros_leidos || 'Libros leidos'}
          esRutaActual={true}
        />
      </MigasDePan>

      <div className="contenido">
    
        <h1 className="titulos-principales">{titulo}</h1>
        <p className="informacion-principal">{descripcion}</p>
        <div className="mt-4 md:w-4/12 xl:w-3/12">
        <Calendario
               fechaMaxima={moment().format('YYYY-MM-DD')}
               fechaMinima={state?.datosInstitucion?.fechaInicioSuscripcion || ''}
               modoRango={true}
               fechaPorDefecto={ [
                state?.estadisticas?.filtros?.fechas?.inicio || queryParams.get('fechaInicio') || fechaPorDefecto?.inicio, 
                state?.estadisticas?.filtros?.fechas?.fin || queryParams.get('fechaFin') || fechaPorDefecto.fin
              ]}
               zIndex={9999}
               modoMultiple={false}
               placeholder={''}
               alCambiar={(fechas)=>actualizarFiltros(fechas)}
        />
        </div>
        <hr className="my-8"/>
        <SelectorRol
          alSeleccionarRol={(rol) => {
            if (rol === 'estudiante') {
              history.push({
                pathname: '/estadisticas/estudiantes/libros-leidos',
                search: `?fechaInicio=${filtros?.fechas?.inicio}&fechaFin=${filtros?.fechas?.fin}`
              })
            }
          }
          }
          rolPorDefecto={'profesor'}
          textos={{
            estudiante:libros_leidos_profesores?.selector_rol?.estudiante || 'Leídos por estudiantes',
            profesor:libros_leidos_profesores?.selector_rol?.profesor || 'Leídos por profesores'
          }}
        />
        <hr className="my-8"/>
        {Boolean(cargando?.estadisticas) === true ?
          <CargandoInformacion />

          :
          <>
            <div className="sm:alineado-verticalmente mb-8">
              <div tabIndex={0} className="focusable-red sm:w-6/12 xl:w-3/12 text-center  lg:text-left">
                <p className='q5-32 red-inv-var2--color '>
                  <span className='icon-star-full text-30 mr-3'></span>
                  {estadisticas?.totalLeidos}  {estadisticas?.totalLeidos !== 1 ? resumen.total_libros.plural : resumen.total_libros.singular}
                </p>
                <p className="r5-14-negro4A">{resumen.total_libros.descripcion}</p>
              </div>
              <div tabIndex={0} className="focusable-red sm:w-6/12 xl:w-3/12  text-center lg:text-left  mt-5 sm:mt-0 xl:ml-5 ">
                <p className='q5-32 primary-inv-var2--color'>
                  <span className='icon-tiempo text-30 mr-3'></span>
                  {estadisticas?.totalTiempoLectura} {resumen.tiempo_acumulado.unidad}
                </p>
                <p className="r5-14-negro4A">{resumen.tiempo_acumulado.descripcion}</p>
              </div>
            </div>

            <TituloSeccion
              titulo={detalle_de}
              fecha={`${rangoFechas.inicio || 'N/A'} - ${rangoFechas.fin || 'N/A'}`}
              alEscribir={(value) => filtrarPorInput(value)}
              input={{
                placeHolder: libros_leidos_profesores?.input_busqueda?.placeholder || 'Buscar por nombre'
              }}
              elementosPersonalizados={
                <div className="my-2 w-full flex  justify-center sm:justify-end">
                  <DescargarReporte
                    nombreArchivo={`${titulo || 'Libros leídos'} (${rangoFechas?.inicio} - ${rangoFechas?.fin})`}
                    tablaInformacion={generarInformacionTabla()}
                  />
                </div>
              }
            />

            <div className="background-var3--bg  mt-5 xl:px-10 xl:py-5 rounded-lg">
              <TablaLibrosLeidos
                alSeleccionarVerDetalle={(libro) => {
                  history.push({
                    pathname: `/estadisticas/profesores/libros-leidos${Boolean(libro?.idLibro) ? `/${libro?.idLibro}` : ''}`,
                    search: `?fechaInicio=${filtros?.fechas?.inicio}&fechaFin=${filtros?.fechas?.fin}`
                  })
                }}
                filtros={filtros}
                datos={estadisticas?.librosFiltrados}
                textosTabla={{ tabla: tabla, boton: botones.ver_detalle, resultados: resultados }}
              />
            </div>

          </>
        }


      </div>
    </>
  )
}
export default LibrosLeidosProfesorComponent;

LibrosLeidosProfesorComponent.propTypes = {
  /**
   * Objeto con los textos que se deben renderizar en la sección
   */
  traducciones: PropTypes.object.isRequired,
}